import { Background } from './components/layout/Background/Background';
import { Navigation } from './components/layout/Navigation';
import { Footer } from './components/layout/Footer';
import { Hero } from './components/sections/Hero';
import { ChatbotSection } from './components/sections/ChatbotSection';
import { Container } from './components/common/Container';
import { ErrorBoundary } from './components/common/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <div className="relative min-h-screen w-full overflow-x-hidden max-w-full">
        {/* Animated Background */}
        <Background />

        {/* Navigation */}
        <Navigation />

        {/* Main Content */}
        <main className="relative z-10 w-full max-w-full overflow-x-hidden">
          {/* Hero Section with Chatbot Integration */}
          <div id="home" className="relative min-h-screen flex flex-col items-center justify-center px-4 py-12 md:py-20">
            <Container>
              {/* Header */}
              <div className="text-center mb-8 md:mb-12">
                <img
                  src="/assets/images/DinoLogo.svg"
                  alt="Fwoozie Logo"
                  className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-4 md:mb-6 animate-float"
                />
                <Hero />
              </div>

              {/* Chatbot Section - Now Primary */}
              <div id="chatbot" className="w-full">
                <ChatbotSection />
              </div>
            </Container>
          </div>

          {/* About Section 
          <section id="about" className="relative py-20 px-4">
            <Container>
              <div className="max-w-3xl mx-auto text-center">
                <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                  Push boundaries of the unknown
                </h2>
                <p className="text-xl text-gray-300 mb-8">
                  Embark on the journey to explore the universe together.
                </p>
              </div>
            </Container>
          </section>
*/}
          {/* CTA Section */}
          <section id="community" className="relative py-20">
            <Container>
              <div className="text-center">
                <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 md:mb-6">
                  Join the Future
                </h2>
                <p className="text-lg md:text-xl text-gray-300 mb-6 md:mb-8">
                  Be part of something bigger
                </p>
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center max-w-md mx-auto sm:max-w-none">
                  <a
                    href="https://x.com/FwoozieCoin"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-primary hover:bg-primary-dark text-dark px-6 sm:px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 text-center"
                  >
                    Follow on X
                  </a>
                  <a
                    href="https://t.me/+y7LWySXUUnY0ZTk5"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-secondary hover:bg-secondary-dark text-white px-6 sm:px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 text-center"
                  >
                    Join Telegram
                  </a>
                </div>
              </div>
            </Container>
          </section>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </ErrorBoundary>
  );
}

export default App;
